import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import ShippingAddress from "./VisitorProduct/ShippingAddress";
import AllShippingAddress from "./VisitorProduct/AllShippingAddress";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../Baseurl";
import { useNavigate } from "react-router-dom";


const Checkout = () => {
  const location = useLocation();
  console.log("🛒 Received Checkout State:", location.state);

  const { cartItems = [], appliedCoupon = null, discount = 0 } = location.state || {};
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [note, setNote] = useState(""); // ✅ Note textarea state 

  const handleAddressSelect = (id) => {
    console.log("Selected Address ID from Checkout:", id);
    setSelectedAddressId(id);
  };

  const subtotal = cartItems.reduce((acc, item) => acc + item.price_with_gst * item.quantity, 0);
  const grandTotal = subtotal - discount;

  const navigate = useNavigate();

  // ✅ Handle order placement
  const handlePlaceOrder = () => {
    if (!selectedAddressId) {
      Swal.fire("Error", "Please select a shipping address.", "error");
      return;
    }
  
    const user_id = localStorage.getItem("cust_id");
  
    const orderData = {
      user_id,
      shipping_address_id: selectedAddressId,
      cart_items: cartItems,
      coupon: appliedCoupon,
      discount,
      note,
      total: grandTotal,
    };
  
    console.log("Redirecting with orderData", orderData);
  
    // 🔁 Redirect to /payment with order data in state
    navigate("/payment", { state: orderData });
  };
  

  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;

  const convertPrice = (inrPrice) => {
    return selectedCurrency === "USD"
      ? `$${(inrPrice / dollarRate).toFixed(2)}`
      : `₹${inrPrice}`;
  };




  return (
    <>
      <VisitorNavbar />
      <div className="container py-3">
        <h4 className="hesd mb-4 text-start">Checkout</h4>
        <div className="row">
          {/* Billing & Shipping Info */}
          <div className="col-md-8">
            <div className="card p-3 mb-3">
              <h5 className="smry text-start">Billing Information</h5>

              <AllShippingAddress onAddressSelect={handleAddressSelect} />

              {/* {selectedAddressId && (
                <div className="mt-3">
                  <strong>Address to be used for delivery:</strong> {selectedAddressId}
                </div>
              )} */}

              <ShippingAddress />

              {/* ✅ Note Textarea */}
              <div className="mt-3 text-start">
                <label htmlFor="orderNote" className="form-label">
                  Order Note:
                </label>
                <textarea
                  id="orderNote"
                  className="form-control"
                  rows="3"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  placeholder="Leave a note for your order (optional)"
                />
              </div>

               
            </div>
          </div>

          {/* Price Summary */}
          <div className="col-md-4">
            <div className="card p-3">
              <h5 className="smry text-start">Cart Summary</h5>

              <div className="d-flex justify-content-between">
                <div className="text-start">Subtotal : <br/> 
                <small style={{fontSize: ".74rem"}} className="text-muted">[Without Delivery Charges]</small>
                </div>
                <div>
                  {/* ₹{subtotal.toFixed(2)} */}
                {convertPrice(subtotal.toFixed(2))}

                </div>
              </div>

              {appliedCoupon && (
                <div className="d-flex justify-content-between">
                  <div>Coupon Applied ({appliedCoupon.coupon_code}):</div>
                  <div className="text-success">
                    
                    (-  {convertPrice(discount.toFixed(2))}
                    {/* ₹{discount.toFixed(2)} */}
                    )

                  {/* {convertPrice(discount.toFixed(2))} */}
                  </div>
                </div>
              )}

              <hr />

              <div className="d-flex justify-content-between grndttl mt-2">
                <div><b>Grand Total:</b> </div>
                <div><strong>
                  {/* ₹{grandTotal.toFixed(2)} */}
                {convertPrice(grandTotal.toFixed(2))}
                </strong></div>
              </div>

              <button className="btn btn-primary w-100 mt-3" onClick={handlePlaceOrder}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Checkout;
